import React from 'react';
import { Container } from 'react-bootstrap';
import {StockTransferForm} from "../Components";

const EditStockTransfer = () => {
  return (
    <Container fluid className="p-0">
      <StockTransferForm isEdit={true} />
    </Container>
  );
};

export default EditStockTransfer;
